import styled, { keyframes } from 'styled-components';
import { Tag, Drawer } from 'antd';

const slide = keyframes`
  0% { left: -30%; }
  100% { left: 100%; }
`;

export const LoadingStrip = styled.div`
  width: 100%;
  height: 2px;
  background-color: #eee;
  overflow: hidden;
  position: relative;
  top: -10px;
`;

export const LoadingBar = styled.div`
  height: 100%;
  width: 30%;
  background-color: #215bff;
  position: absolute;
  animation: ${slide} 1.5s linear infinite;
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    align-items: baseline;
  }

  .ant-drawer-body {
    padding: 0;
  }

  .ant-menu-light {
    background: unset;
  }
`;

export const StyledNoFlow = styled.div`
  display: flex;
  padding: 20px;
`;

export const StyledTitle = styled.div`
  display: flex;

  sup {
    color: #999;
    top: -0.1em;
  }
`;

export const SelectWrapper = styled.div`
  width: 100px;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  background-color: white;
  border: 1px solid rgb(217 217 217);
  cursor: pointer;
  font-size: 12px;
  line-height: 20px;
  height: 22px;
`;

export const StyledCheckBox = styled.div`
  width: 100%;

  .ant-checkbox-wrapper {
    width: 100%;

    .ant-checkbox-wrapper-in-form-item {
      margin-inline-end: 0;
    }
  }

  .ant-checkbox + span {
    padding-inline-start: 8px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
    max-height: calc(1.4em * 2); /* 2 lines with line-height 1.4 */
  }
`;

export const MetricDivider = styled.div`
  height: 1px;
  background: #979797;
  opacity: 0.5;
  margin-bottom: 5px;
  width: 96%;
`;

export const StyledLeftPanel = styled.div`
  background: rgb(245 245 245);
  width: 250px;
  overflow-y: auto;

  .create-metric-box {
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 20px 15px;
    background: #fff;
    margin: 15px;
    display: flex;
    flex-direction: column;
  }

  b {
    font-weight: 500;
  }
`;

export const CheckBoxList = styled.div`
  border: 1px transparent solid;
  width: 100%;
  padding-left: 8px;
`;

export const RowWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const StyledText = styled.div`
  padding: 2px 0;
  font-size: 1.1rem;
  font-weight: 500;
  display: flex;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;

  .ant-menu-light.ant-menu-root.ant-menu-vertical {
    border-inline-end: none;
    border: none;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-left: 0;
  border-left: 1px solid #e5e5e5;
  padding-left: 10px;
  padding-top: 10px;
`;

export const CheckboxWrapper = styled.div<{ count: number }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  padding: 8px 0;
  align-items: start;
`;

export const StyledSPITag = styled(Tag)`
  margin-left: 20px;
  font-size: 1em;
  color: white;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const FlexFill = styled.div`
  flex: 1;
`;

export const CountText = styled.div`
  margin: 0 10px;
  line-height: 2;
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 20px;
  font-size: 20px;
  font-weight: 400;

  .ant-input-search-button {
    pointer-events: none;
  }
`;

export const CategoryWrapper = styled.div`
  width: 96%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  margin-top: 5px;

  .activate-button {
    font-size: 16px;
    color: rgb(0 0 0 / 45%);

    &:hover {
      color: #0046ff;
    }
  }

  .create-button {
    height: 20px;
    padding: 0 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #e6edff;
    color: #0046ff;
    font-size: 12px;
    border: none;
    border-radius: 2px;
  }
`;

export const StyledTitleHeader = styled.div`
  display: flex;
  margin: 10px 20px;
  align-items: center;
  justify-content: space-between;

  h3 {
    margin: 0;
  }
`;

export const StyledBetaMetric = styled.sup`
  color: #0046ff;
  font-size: 10px;
`;

export const PercentileIcon = styled.span`
  font-weight: 600;
  margin-left: 4px;
  color: #fff;
  background-color: #666;
  padding: 2px 4px;
  border-radius: 10px;
  align-items: center;
  font-size: 8px;
`;
